module.exports = __webpack_public_path__ + "img/MnC_logo.cd04484f.svg";